import FundUnicefTemplate from '@/page-blocks/about-us/clear/fund/unicef/FundUnicefTemplate';
import ReportUnicef2024 from '@/page-blocks/about-us/clear/fund/unicef/report.unicef_2024';
import { PageProps } from 'gatsby';
import React from 'react';

const FundUnicefIndex: React.FC<PageProps> = (props) => (
  <FundUnicefTemplate year={2024} {...props}>
    <ReportUnicef2024 />
  </FundUnicefTemplate>
);

export default FundUnicefIndex;
